

export const routerConfig = {
    '/login': {
        title: 'Login-FaceID'
    },
    '/reset-password': {
        title: 'Reset Password-FaceID'
    },
    '/forget-password': {
        title: 'Find Password-FaceID'
    },
    '/pages/password/update': {
        title: 'Change Password'
    },
    '/pages/app/appkey': {
        title: 'AppKey'
    },
    '/pages/app/appkey/view/:id': {
        title: 'Appkey Check',
        breadcrumb: [
            ['AppKey', '/pages/app/appkey'],
            ['Appkey Check']
        ]
    },
    '/pages/app/bundle': {
        title: 'Mobile Client'
    },
    '/pages/consumption': {
        title: 'Face Verification',
        breadcrumb: [
            ['Face Verification'],
        ]
    },
    '/pages/ktp-consumption': {
        title: 'Indonesia ID card',
        breadcrumb: [
            ['Indonesia ID card'],
        ]
    },'/pages/app/bundle/new':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id/edit':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/sdk-download':{
        title: 'SDK DOWNLOAD',
        breadcrumb: [
            ['SDK Download'],
        ]
    },'/pages/sdk-scenes':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/create':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/edit/:id':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/verify-scenes':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/create':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/edit/:id':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/encryption':{
        title: 'Encryption',
        breadcrumb: [
            ['Encryption'],
        ]
    }

};



// WEBPACK FOOTER //
// ./src/utils/routerConfig.js